import React, { Component } from 'react'
import moment from 'moment'
import Select from 'react-select'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Bar } from 'react-chartjs-2'
import { portFetchAll } from 'actions/portAction'
import { AvForm } from 'availity-reactstrap-validation'
import { orderPerBulan } from '../../actions/dashboardAction'
import { msttrayekFetchAll } from '../../actions/msttrayekAction'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'
import { Card, CardHeader, CardBody, Button, Row, Col, FormGroup } from 'reactstrap'

let isDefaultMonth = false
let isDefaultTrayek = false
let isDefaultPortOrigin = false
let isDefaultPortDestination = false
let thisMonth = moment().format('M')
let month_option = [
  { value: 1, label: 'Januari' },
  { value: 2, label: 'Februari' },
  { value: 3, label: 'Maret' },
  { value: 4, label: 'April' },
  { value: 5, label: 'Mei' },
  { value: 6, label: 'Juni' },
  { value: 7, label: 'Juli' },
  { value: 8, label: 'Agustus' },
  { value: 9, label: 'September' },
  { value: 10, label: 'Oktober' },
  { value: 11, label: 'November' },
  { value: 12, label: 'Desember' }
]

class OrderPerBulan extends Component {
  constructor(props) {
    super(props)
    this.state = {
      month: '',
      month_label: '',
      trayek_id: '',
      trayek_label: '',
      port_origin_id: '',
      port_origin_label: '',
      port_destination_id: '',
      port_destination_label: ''
    }

    this.selectMonth = this.selectMonth.bind(this)
    this.selectTrayek = this.selectTrayek.bind(this)
    this.selectPortOrigin = this.selectPortOrigin.bind(this)
    this.selectPortDestination = this.selectPortDestination.bind(this)
    this.handleFilter = this.handleFilter.bind(this)
  }

  componentDidMount() {
    let data = {
      month: thisMonth
    }

    this.props.orderPerBulan(data)
    this.props.msttrayekFetchAll()
    this.props.portFetchAll()
  }

  componentWillUnmount() {
    isDefaultMonth = false
    isDefaultTrayek = false
    isDefaultPortOrigin = false
    isDefaultPortDestination = false
  }

  selectMonth(opt) {
    if (opt) {
      this.setState({
        month: opt.value,
        month_label: opt.label
      })
    } else {
      this.setState({
        month: '',
        month_label: ''
      })
    }
  }

  selectTrayek(opt) {
    if (opt) {
      this.setState({
        trayek_id: opt.value,
        trayek_label: opt.label
      })
    } else {
      this.setState({
        trayek_id: '',
        trayek_label: ''
      })
    }
  }

  selectPortOrigin(opt) {
    if (opt) {
      this.setState({
        port_origin_id: opt.value,
        port_origin_label: opt.label
      })
    } else {
      this.setState({
        port_origin_id: '',
        port_origin_label: ''
      })
    }
  }

  selectPortDestination(opt) {
    if (opt) {
      this.setState({
        port_destination_id: opt.value,
        port_destination_label: opt.label
      })
    } else {
      this.setState({
        port_destination_id: '',
        port_destination_label: ''
      })
    }
  }

  handleFilter(event, values) {
    if (this.state.month) {
      values.month = this.state.month
      isDefaultMonth = true
    } else {
      values.month = thisMonth
      isDefaultMonth = false
    }

    if (this.state.trayek_id) {
      values.trayek_id = this.state.trayek_id
      isDefaultTrayek = true
    } else {
      delete values.trayek_id
      isDefaultTrayek = false
    }

    if (this.state.port_origin_id) {
      values.port_origin_id = this.state.port_origin_id
      isDefaultPortOrigin = true
    } else {
      delete values.port_origin_id
      isDefaultPortOrigin = false
    }

    if (this.state.port_destination_id) {
      values.port_destination_id = this.state.port_destination_id
      isDefaultPortDestination = true
    } else {
      delete values.port_destination_id
      isDefaultPortDestination = false
    }

    values.length = this.state.perPage

    this.props.orderPerBulan(values)
  }

  renderData() {
    if (this.props.orderPerBulanIsSuccess) {
      let defaultValues = {
        month: this.state.month,
        month_label: this.state.month_label,
        trayek_id: this.state.trayek_id,
        trayek_label: this.state.trayek_label,
        port_origin_id: this.state.port_origin_id,
        port_origin_label: this.state.port_origin_label,
        port_destination_id: this.state.port_destination_id,
        port_destination_label: this.state.port_destination_label,
      }

      const { month } = this.state.month
      const { trayek_id } = this.state.trayek_id
      const { port_origin_id } = this.state.port_origin_id
      const { port_destination_id } = this.state.port_destination_id
      const defaultValueMonth = { label: defaultValues.month_label, value: defaultValues.month }
      const defaultValueTrayek = { label: defaultValues.trayek_label, value: defaultValues.trayek_id }
      const defaultValuePortOrigin = { label: defaultValues.port_origin_label, value: defaultValues.port_origin_id }
      const defaultValuePortDestination = { label: defaultValues.port_destination_label, value: defaultValues.port_destination_id }

      let orderPerBulanData = this.props.orderPerBulanData.report
      let labels = []
      let data = []

      orderPerBulanData.forEach(val => {
        let arrLabel = val.kode_trayek + ' ' + val.origin + ' - ' + val.destination
        let arrData = val.count

        labels.push(arrLabel)
        data.push(arrData)
      })

      const bar_order = {
        labels: labels,
        datasets: [
          {
            label: 'Jumlah Order',
            backgroundColor: 'rgba(25,181,254,0.2)',
            borderColor: 'rgba(25,181,254,1)',
            borderWidth: 1,
            hoverBackgroundColor: 'rgba(25,181,254,0.4)',
            hoverBorderColor: 'rgba(25,181,254,1)',
            data: data,
          },
        ],
      }

      const options = {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        },
        tooltips: {
          enabled: false,
          custom: CustomTooltips
        },
        maintainAspectRatio: false
      }

      return (
        <div>
          <Card>
            <CardHeader>
              <h5>Order masuk bulan</h5>
              <hr />
              <AvForm onValidSubmit={this.handleFilter} model={defaultValues}>
                <Row>
                  {this.props.trayekIsSuccess &&
                    <Col>
                      <FormGroup>
                        <Select name="trayek_id"
                          value={trayek_id}
                          isClearable
                          placeholder="Trayek..."
                          defaultValue={isDefaultTrayek ? defaultValueTrayek : false}
                          onChange={this.selectTrayek}
                          options={this.props.msttrayeks.data}
                          id="trayek_id"
                          inputId="input_trayek_id"
                          instanceId="instance_trayek_id"
                        />
                      </FormGroup>
                    </Col>
                  }
                  <Col>
                    <FormGroup>
                      <Select name="month"
                        value={month}
                        isClearable
                        placeholder="Bulan..."
                        defaultValue={isDefaultMonth ? defaultValueMonth : false}
                        onChange={this.selectMonth}
                        options={month_option}
                        id="month"
                        inputId="input_month"
                        instanceId="instance_month"
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  {this.props.portIsSuccess &&
                    <Col>
                      <FormGroup>
                        <Select name="port_origin_id"
                          value={port_origin_id}
                          isClearable
                          placeholder="Pelabuhan asal..."
                          defaultValue={isDefaultPortOrigin ? defaultValuePortOrigin : false}
                          onChange={this.selectPortOrigin}
                          options={this.props.ports.data}
                          id="port_origin_id"
                          inputId="input_port_origin_id"
                          instanceId="instance_port_origin_id" />
                      </FormGroup>
                    </Col>
                  }
                  {this.props.portIsSuccess &&
                    <Col>
                      <FormGroup>
                        <Select name="port_destinaton_id"
                          value={port_destination_id}
                          isClearable
                          placeholder="Pelabuhan tujuan..."
                          defaultValue={isDefaultPortDestination ? defaultValuePortDestination : false}
                          onChange={this.selectPortDestination}
                          options={this.props.ports.data}
                          id="port_destinaton_id"
                          inputId="input_port_destinaton_id"
                          instanceId="instance_port_destinaton_id" />
                      </FormGroup>
                    </Col>
                  }
                  <Col>
                    <FormGroup className="form-actions">
                      <Button type="submit" size="md" color="primary" className=" btn-brand mr-1 mb-1">
                        <i className="fa fa-search"></i> <span>Proses </span>
                      </Button>
                    </FormGroup>
                  </Col>
                </Row>
              </AvForm>
            </CardHeader>
            <CardBody>
              <div className="chart-wrapper">
                <Bar data={bar_order} options={options} height={100} />
              </div>
            </CardBody>
          </Card>
        </div >
      )
    }
  }

  render() {
    if (this.props.orderPerBulanIsLoading) {
      return (
        <div>
          <p>Loading ..... </p>
        </div>
      )
    }

    if (this.props.orderPerBulanHasError) {
      return (
        <div>
          <p>Silahkan mencoba beberapa saat lagi, pastikan anda terkoneksi dengan internet</p>
        </div>
      )
    }

    return (
      <div>
        {this.renderData()}
      </div>
    )
  }
}

OrderPerBulan.propTypes = {
  orderPerBulanIsSuccess: PropTypes.bool.isRequired,
  orderPerBulanHasError: PropTypes.bool.isRequired,
  orderPerBulanIsLoading: PropTypes.bool.isRequired
}

const mapStateToProps = (state) => {
  return {
    orderPerBulanData: state.dashboard.orderPerBulanData,
    orderPerBulanIsSuccess: state.dashboard.orderPerBulanSuccess,
    orderPerBulanHasError: state.dashboard.orderPerBulanError,
    orderPerBulanIsLoading: state.dashboard.orderPerBulanLoading,

    ports: state.ports.ports,
    portHasError: state.ports.portGetError,
    portIsSuccess: state.ports.portGetSuccess,
    portIsLoading: state.ports.portGetLoading,

    msttrayeks: state.msttrayeks.msttrayeks,
    trayekHasError: state.msttrayeks.msttrayekGetError,
    trayekIsSuccess: state.msttrayeks.msttrayekGetSuccess,
    trayekIsLoading: state.msttrayeks.msttrayekGetLoading,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    orderPerBulan: (data) => dispatch(orderPerBulan(data)),
    msttrayekFetchAll: () => dispatch(msttrayekFetchAll()),
    portFetchAll: () => dispatch(portFetchAll())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderPerBulan)